import Contact from "./Components/Contact";
import Features from "./Components/Features";
import HeroComponent from "./Components/Hero";
import Projects from "./Components/Projects";

export default function IndexPage() {
    return (
        <>

            <Features />
            <Projects />
            <a href="/projects" className="bg-[#0077d3] hover:bg-[#0077d3]/90  w-32 text-white p-4 rounded-lg mx-auto mt-8 flex items-center justify-center shadow-lg  transition-all duration-300" data-aos="fade-down">
                Daha Fazla
            </a>
            <HeroComponent />


            <Contact />
        </>
    )
}